import React, {useEffect, useRef, useState} from "react";
import "./Home.css";
import "../components/carousel/CardCarousel.css";
import CardLandingPage from "../components/CardLandingPage";
import FAQAccordion from "../components/FAQAccordion";
import ReviewCarousel from "../components/ReviewCarousel";

function LandingPage() {
    // const [sites, setSites] = useState([]);
    const partnerRef = useRef();


    const scrollToComponent = () => {
        partnerRef.current.scrollIntoView({behavior: "smooth"});
    };

    const handleAffiliateRegister = () => {
        window.location.href = "https://app.psicopatici.com";
    };
    const handleAffiliateLogin = () => {
        window.location.href = "https://app.psicopatici.com/sign-in";
    };

    return (
        <>
            <div style={{marginTop: "69px"}}>
                <div
                    style={{padding: "80px 0px", backgroundColor: "#fef4ea"}}
                    className="text-center"
                >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <h1
                                    className="fw-bold"
                                    style={{fontSize: "45px", lineHeight: "50px"}}
                                >
                                    Guadagna promuovendo Psicopatici Italia: uno dei brand più virali del momento.
                                </h1>
                                <p style={{fontSize: "18px"}}>
                                    Candidati gratis e inizia a guadagnare diventando Partner ufficiale di Psicopatici
                                    Italia.
                                    Non serve che tu abbia competenze elevate: avrai accesso gratuito a strumenti,
                                    risorse e guide facili da utilizzare e fondamentali per far crescere i tuoi guadagni
                                    e i nostri successi!
                                </p>
                                <div
                                    className="d-flex flex-column flex-md-row justify-content-center align-items-center"
                                    style={{gap: "20px"}}>
                                    <button
                                        style={{width: "340px",height: "50px"}}
                                        onClick={scrollToComponent}
                                        className="button buttonHero mt-4"
                                    >
                                        Diventa un Partner
                                    </button>
                                    <button
                                        style={{width: "340px",height: "50px"}}
                                        onClick={handleAffiliateLogin}
                                        className="button buttonHero mt-4"
                                    >
                                        Accedi al Portale Partner
                                    </button>
                                </div>
                                <div className="mt-5 d-flex justify-content-center">
                                    <button
                                        style={{width: "340px",height: "50px"}}
                                        onClick={() => window.open('/totemtouch', '_blank', 'noopener,noreferrer')}
                                        className="button buttonHero"
                                    >
                                        Candidatura Totem Touch
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style={{backgroundColor: "#f6f9fc", padding: "60px 0px"}}
                    className="flex flex-column"
                >
                    <div className="marginResp">
                        <div className="text-center">
                            <h2 className="fw-bold" style={{fontSize: "35px"}}>
                                Come guadagnano i Partner di Psicopatici Italia?
                            </h2>
                        </div>
                        <div className="row mt-5">
                            <div
                                className="respWhy col-lg-4 col-sm-12 d-sm-flex d-lg-block flex-column align-items-center text-sm-center text-lg-start">
                                <img
                                    className="imgWhy"
                                    src="https://www.hubspot.com/hs-fs/hubfs/2023_CRM_Recurring_Payments-.png?width=86&height=86&name=2023_CRM_Recurring_Payments-.png"
                                />
                                <h4 style={{fontSize: "19px"}} className="fw-bold mt-3">
                                    Guadagni remunerativi e crescenti
                                </h4>
                                <p style={{fontSize: "16px"}}>
                                    Con Psicopatici Italia ottieni commissioni sempre più elevate su vendite dirette ed
                                    indirette e da clienti acquisiti dalla tua rete.
                                    Il tutto documentato attraverso una dashboard dedicata e tramite un sistema di
                                    marketing automation, anche quando non potrai essere operativo.
                                </p>
                            </div>
                            <div
                                className="respWhy col-lg-4 col-sm-12 d-sm-flex d-lg-block flex-column align-items-center text-sm-center text-lg-start">
                                <img
                                    className="imgWhy"
                                    src="https://www.hubspot.com/hs-fs/hubfs/2023_Partnership3%201-1.png?width=86&height=86&name=2023_Partnership3%201-1.png"
                                />
                                <h4 style={{fontSize: "19px"}} className="fw-bold mt-3">
                                    Più cresci, più guadagni
                                </h4>
                                <p style={{fontSize: "16px"}}>
                                    Ogni vendita generata ti permetterà di accedere a commissioni sempre più
                                    vantaggiose.
                                    In aggiunta, ogni nuova registrazione cliente ti riconoscerà crediti da poter
                                    utilizzare come buoni acquisto personali o come strumento promozionale per far
                                    accrescere la tua community.
                                </p>
                            </div>
                            <div
                                className="respWhy col-lg-4 col-sm-12 d-sm-flex d-lg-block flex-column align-items-center text-sm-center text-lg-start">
                                <img
                                    className="imgWhy"
                                    src="https://www.hubspot.com/hs-fs/hubfs/2023_Diagram1%20(1).png?width=86&height=86&name=2023_Diagram1%20(1).png"
                                />
                                <h4 style={{fontSize: "19px"}} className="fw-bold mt-3">
                                    Risorse e strumenti gratuiti
                                </h4>
                                <p style={{fontSize: "16px"}}>
                                    Avrai sempre accesso
                                    gratuito a:
                                    <br/>
                                    <ul>
                                        <li>Banner, grafiche e codici sconto personalizzabili</li>
                                        <li>Contenuti ufficiali nella Libreria Virtuale</li>
                                        <li>Kit creativi e linee guida</li>
                                        <li>Supporto continuo e aggiornamenti dal brand</li>
                                    </ul>
                                </p>
                            </div>
                        </div>

                        <div className={"flex justify-content-center"}>
                            <button style={{width: "300px"}}
                                    onClick={scrollToComponent}
                                    className="button buttonHero mt-4"
                            >
                                Diventa un Partner
                            </button>
                        </div>
                    </div>

                </div>

                <div style={{padding: "60px 0px"}}>
                    <div style={{margin: "0px 15%"}}>
                        <div className="text-center">
                            <h2 className="fw-bold" style={{fontSize: "35px"}}>
                                Come iniziare a guadagnare?
                            </h2>
                        </div>
                        <div className="d-flex justify-content-center gap-3 my-5">
                            <div>
                                <CardLandingPage
                                    id={1}
                                    title="Registrati in pochi minuti"
                                    content="Compila il modulo online, che troverai nella specifica pagina Partner, con i dati richiesti. La tua candidatura verrà valutata entro 24 ore e, se approvata, sarai subito operativo."
                                />
                            </div>
                            <div>
                                <CardLandingPage
                                    id={2}
                                    title="Accedi alla tua dashboard personale"
                                    content="Se approvata, riceverai via email le tue credenziali per accedere all’area riservata, dove potrai generare il tuo link partner, creare contenuti e monitorare in tempo reale vendite, commissioni e bonus crediti."
                                />
                            </div>
                            <div>
                                <CardLandingPage
                                    id={3}
                                    title="Inizia a guadagnare"
                                    content="Non ti resta che condividere il tuo link partner con i tuoi follower o con chi vorrai e far crescere la tua rete per iniziare a guadagnare commissioni remunerative su ogni acquisto.
I pagamenti saranno trasparenti e puntuali, erogati a cadenza trimestrale.
"
                                />
                            </div>
                        </div>
                        <div className={"flex justify-content-center"}>
                            <button style={{width: "300px"}}
                                    onClick={scrollToComponent}
                                    className="button buttonHero mt-4"
                            >
                                Diventa un Partner
                            </button>
                        </div>
                    </div>
                </div>

                <section ref={partnerRef} className="bg-features-bg py-16">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-8">
                            <h2 className="text-4xl font-bold text-foreground mb-4">
                                Scegli chi vuoi diventare
                            </h2>
                        </div>
                        <ReviewCarousel/>
                    </div>
                </section>

                <div style={{padding: "60px 0px"}}>
                    <div className="marginResp">
                        <div className="text-center">
                            <h2 className="fw-bold" style={{fontSize: "35px"}}>
                                Domande Frequenti
                            </h2>
                        </div>
                        <div className="mt-5">
                            <FAQAccordion/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LandingPage;
